export enum EnumEstadoProgramaAuditoria {
    EnConstruccion = 1,
    ProgramaAprobado = 2
}